import GeoJSON from "ol/format/GeoJSON.js";

export default function toTurf(feat, projection, format) {
    if (!format) {
        format = new GeoJSON();
    }
    var item1 = format.writeFeatureObject(feat, { featureProjection: projection });
    return item1;
}
